import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: [0.33, 1, 0.68, 1] },
};

export const MarqueeBand = () => {
  const text = "KRAV MAGA  //  DELHI & GURGAON  //  PERSONAL TRAINING  //  GROUP CLASSES  //  INSTINCT  //  REAL WORLD DEFENSE  //  ";
  return (
    <div data-testid="marquee-band">
      <div className="hazard-stripe" aria-hidden="true" />
      <div className="py-3 bg-sig overflow-hidden">
        <div className="marquee-track">
          {[...Array(4)].map((_, i) => (
            <span
              key={i}
              className="text-sigfg text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase font-['Oswald'] whitespace-nowrap px-2"
            >
              {text}
            </span>
          ))}
        </div>
      </div>
      <div className="hazard-stripe" aria-hidden="true" />
    </div>
  );
};

export const PositioningSection = () => {
  return (
    <section
      id="positioning"
      data-testid="positioning-section"
      className="relative px-6 md:px-16 lg:px-24 py-12 md:py-16"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
        <motion.div {...fadeUp} className="md:col-span-5">
          <div className="brass-line mb-4" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-sig font-['IBM_Plex_Sans'] block mb-4">
            The Position
          </span>
          <p className="text-sm md:text-base leading-relaxed text-mute font-['IBM_Plex_Sans'] font-light">
            Developed by the Israeli Defense Forces. Refined for real life.
          </p>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-mute font-['IBM_Plex_Sans'] font-light">
            INSTINCT sits at the intersection of real-world utility, mental sharpness, and identity. The people who train here are switched on, serious, and unflinching.
          </p>
        </motion.div>

        <motion.div
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.15 }}
          className="md:col-span-7 md:pl-12 flex items-center"
        >
          <blockquote
            data-testid="positioning-quote"
            className="border-l-2 border-sig pl-6 md:pl-10"
          >
            <p className="font-['Oswald'] text-2xl md:text-4xl lg:text-5xl font-bold uppercase leading-[1.05] tracking-tight text-ink">
              Train for Real Life.{" "}
              <span className="text-sig">No rules.</span>{" "}
              No performance. Just capability.
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>
  );
};
